(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9838],{

/***/ 16134:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vacation-rentals/[_name]",
      function () {
        return __webpack_require__(14439);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Services; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/elements/Container/index.js
var Container = __webpack_require__(51524);
// EXTERNAL MODULE: ./components/elements/SlickSlider/index.js + 2 modules
var SlickSlider = __webpack_require__(12817);
// EXTERNAL MODULE: ./components/layout/Column/index.js
var Column = __webpack_require__(70539);
// EXTERNAL MODULE: ./components/layout/Columns/index.js
var Columns = __webpack_require__(40050);
// EXTERNAL MODULE: ./components/pages/common/Services/components/Item/styles.module.scss
var styles_module = __webpack_require__(27033);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./components/elements/LazyImage/index.js
var LazyImage = __webpack_require__(20027);
// EXTERNAL MODULE: ./components/helpers/getS3Url.js
var getS3Url = __webpack_require__(27895);
;// CONCATENATED MODULE: ./components/pages/common/Services/components/Item/index.js




var Item = function(param) {
    var item = param.item;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).card,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).card__image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage/* default */.Z, {
                    alt: "Image Feature ".concat(item.title),
                    layout: "fill",
                    objectFit: "cover",
                    objectPosition: "50% 68%",
                    sizes: "(min-width: 1250px) 300px, (max-width: 1250px) 100vw, 70vw",
                    src: item.cloudflare_picture ? (0,getS3Url/* getS3Url */.v)(item.cloudflare_picture, "640") : (0,getS3Url/* getS3Url */.v)(item.picture)
                }, item.title)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (styles_module_default()).card__title,
                children: item.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: item.short_description
                }
            })
        ]
    });
};
/* harmony default export */ var components_Item = (Item);

// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./components/pages/common/Services/styles.module.scss
var Services_styles_module = __webpack_require__(71550);
var Services_styles_module_default = /*#__PURE__*/__webpack_require__.n(Services_styles_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/pages/common/Services/index.js









var Services = function(param) {
    var services = param.services;
    var ref = (0,ResponsiveContext/* useResponsive */.F)(), isTablet = ref.isTablet, isSmallMobile = ref.isSmallMobile, isDesktop = ref.isDesktop;
    var ref1 = (0,react.useState)(false), loaded = ref1[0], setLoaded = ref1[1];
    (0,react.useEffect)(function() {
        return setLoaded(true);
    }, []);
    if (isTablet && services && loaded) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SlickSlider/* default */.Z, {
            className: (Services_styles_module_default()).experience,
            arrows: false,
            pagination: true,
            infinite: false,
            variableWidth: true,
            slidesToScroll: isSmallMobile ? 1 : 2,
            slidesToShow: isSmallMobile ? 1 : 2,
            children: services.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Item, {
                    item: item
                }, "service-".concat(index));
            })
        });
    }
    if (loaded) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
            variant: [
                "-xl"
            ],
            children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* default */.Z, {
                        className: (Services_styles_module_default()).locations,
                        children: services && services.map(function(item, index) {
                            return index < 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                                spans: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Item, {
                                    item: item
                                })
                            }, "service-".concat(index));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* default */.Z, {
                        className: (Services_styles_module_default()).locations,
                        variant: [
                            "-align-center"
                        ],
                        children: services && services.map(function(item, index) {
                            return index > 3 && index <= 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                                spans: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Item, {
                                    item: item
                                })
                            }, "service-".concat(index));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* default */.Z, {
                        className: (Services_styles_module_default()).locations,
                        variant: [
                            "-align-center"
                        ],
                        children: services && services.map(function(item, index) {
                            return index > 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                                spans: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Item, {
                                    item: item
                                })
                            }, "service-".concat(index));
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* default */.Z, {
                variant: [
                    "-align-center"
                ],
                children: services && services.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* default */.Z, {
                        spans: 20,
                        className: (Services_styles_module_default()).column,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Item, {
                            item: item
                        })
                    }, "service-".concat(index));
                })
            })
        });
    }
    return;
};
/* harmony default export */ var common_Services = (Services);


/***/ }),

/***/ 14439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _name_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/templates/Page/index.js + 16 modules
var Page = __webpack_require__(51904);
// EXTERNAL MODULE: ./components/pages/single-property/Welcome/index.js
var Welcome = __webpack_require__(51219);
// EXTERNAL MODULE: ./components/pages/common/Services/index.js + 1 modules
var Services = __webpack_require__(24879);
// EXTERNAL MODULE: ./components/layout/Columns/index.js
var Columns = __webpack_require__(40050);
// EXTERNAL MODULE: ./components/layout/Column/index.js
var Column = __webpack_require__(70539);
// EXTERNAL MODULE: ./components/elements/Section/index.js
var Section = __webpack_require__(24447);
// EXTERNAL MODULE: ./components/elements/Container/index.js
var Container = __webpack_require__(51524);
// EXTERNAL MODULE: ./components/pages/single-property/Bonuses/styles.module.scss
var styles_module = __webpack_require__(94411);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
;// CONCATENATED MODULE: ./components/pages/single-property/Bonuses/index.js








var Bonuses = function(param) {
    var services = param.services, title = param.title, label = param.label;
    var isTablet = (0,ResponsiveContext/* useResponsive */.F)().isTablet;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section["default"], {
        variant: [
            "gray",
            "o-hidden"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Columns/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* default */.Z, {
                        spans: isTablet ? 12 : 6,
                        children: [
                            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).intro,
                                children: label
                            }),
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: (styles_module_default()).title,
                                children: title
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Services/* default */.Z, {
                services: services
            })
        ]
    });
};
/* harmony default export */ var single_property_Bonuses = (Bonuses);

// EXTERNAL MODULE: ./components/pages/single-property/Introduction/index.js
var Introduction = __webpack_require__(38122);
// EXTERNAL MODULE: ./components/pages/single-property/Gallery/index.js + 3 modules
var Gallery = __webpack_require__(44731);
// EXTERNAL MODULE: ./components/pages/single-property/Details/index.js + 1 modules
var Details = __webpack_require__(12626);
// EXTERNAL MODULE: ./components/pages/single-property/Availability/index.js + 1 modules
var Availability = __webpack_require__(74102);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/configs/axios.js
var axios = __webpack_require__(92375);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(79697);
// EXTERNAL MODULE: ./node_modules/lodash-es/capitalize.js
var capitalize = __webpack_require__(26786);
// EXTERNAL MODULE: ./pages/vacation-rentals/styles.module.scss
var vacation_rentals_styles_module = __webpack_require__(76283);
var vacation_rentals_styles_module_default = /*#__PURE__*/__webpack_require__.n(vacation_rentals_styles_module);
// EXTERNAL MODULE: ./components/pages/single-property/components/Card/index.js + 8 modules
var Card = __webpack_require__(87086);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./components/pages/single-property/Map/index.js + 1 modules
var Map = __webpack_require__(15005);
// EXTERNAL MODULE: ./providers/SearchContext.js
var SearchContext = __webpack_require__(65079);
;// CONCATENATED MODULE: ./node_modules/lodash-es/join.js
/** Used for built-in method references. */
var arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeJoin = arrayProto.join;

/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */
function join(array, separator) {
  return array == null ? '' : nativeJoin.call(array, separator);
}

/* harmony default export */ var lodash_es_join = (join);

;// CONCATENATED MODULE: ./components/helpers/iterateArray.js

var iterateArray = function(array) {
    var word = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "or";
    return lodash_es_join(array.map(function(bedroom, index) {
        var bedroomCount = array.length;
        if (index === bedroomCount - 2 || bedroomCount === 1) {
            return bedroom;
        }
        if (index === bedroomCount - 1) {
            return "".concat(word, " ").concat(bedroom);
        }
        return "".concat(bedroom, ",");
    }), " ");
};
/* harmony default export */ var helpers_iterateArray = (iterateArray);

// EXTERNAL MODULE: ./pages/404/index.js
var _404 = __webpack_require__(6553);
// EXTERNAL MODULE: ./components/helpers/getS3Url.js
var getS3Url = __webpack_require__(27895);
// EXTERNAL MODULE: ./components/pages/single-property/Updates/styles.module.scss
var Updates_styles_module = __webpack_require__(56170);
var Updates_styles_module_default = /*#__PURE__*/__webpack_require__.n(Updates_styles_module);
;// CONCATENATED MODULE: ./components/pages/single-property/Updates/index.js






var Updates = function(param) {
    var _title = param.title, title = _title === void 0 ? "Updates" : _title, entries = param.entries;
    if (entries && !(0,isEmpty/* default */.Z)(entries)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section["default"], {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container["default"], {
                variant: [
                    "-xs3"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (Updates_styles_module_default()).title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: entries.map(function(update, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Updates_styles_module_default()).update,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Updates_styles_module_default()).update__left,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Updates_styles_module_default()).update__bullet
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Updates_styles_module_default()).update__content,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Updates_styles_module_default()).update__right,
                                                children: moment_default()(update.date).utc().format("DD MMM YYYY")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: update.description
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }, "update-number-".concat(index));
                        })
                    })
                ]
            })
        });
    }
    return;
};
/* harmony default export */ var single_property_Updates = (Updates);

// EXTERNAL MODULE: ./providers/authProvider.js
var authProvider = __webpack_require__(89149);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/templates/LoadingPage/index.js
var LoadingPage = __webpack_require__(93019);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./pages/vacation-rentals/[_name].js





















var Reviews = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4359).then(__webpack_require__.bind(__webpack_require__, 14359));
});
var Amenities = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8322).then(__webpack_require__.bind(__webpack_require__, 88322));
});
var Contact = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 346).then(__webpack_require__.bind(__webpack_require__, 90346));
});
var Rentals = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5585), __webpack_require__.e(9459)]).then(__webpack_require__.bind(__webpack_require__, 12943));
});






var Property = function(param) {
    var property = param.property, notFound = param.notFound, headerTranslation = param.headerTranslation, footerTranslation = param.footerTranslation, contactTranslation = param.contactTranslation, pageTranslations = param.pageTranslations, ctaTranslation = param.ctaTranslation, recommendedProperties = param.recommendedProperties, filteredDates = param.filteredDates, initialMinNight = param.initialMinNight, bedrooms = param.bedrooms, bathrooms = param.bathrooms;
    var ref;
    var ref1 = (0,react.useState)([]), blockedDates = ref1[0], setBlockedDates = ref1[1];
    (0,react.useEffect)(function() {
        if (filteredDates && filteredDates.length > 0) {
            var convertedDates = filteredDates.map(function(dateStr) {
                return moment_default().utc(dateStr);
            });
            setBlockedDates(convertedDates);
        }
    }, [
        filteredDates
    ]);
    var router = (0,next_router.useRouter)();
    var isTablet = (0,ResponsiveContext/* useResponsive */.F)().isTablet;
    var ref2 = (0,react.useState)(initialMinNight), minNights = ref2[0], setMinNights = ref2[1];
    var search = (0,SearchContext/* useSearchContext */.AB)().search;
    var isAuthorized = (0,authProvider/* useAuthContext */.Eu)().isAuthorized;
    var loadingTitle = {
        en: "Loading",
        fr: "Chargement",
        es: "Cargando",
        nl: "Bezig met laden"
    };
    var bedroomOptions = (property === null || property === void 0 ? void 0 : property.bedroom_option) && (property === null || property === void 0 ? void 0 : (ref = property.bedroom_option) === null || ref === void 0 ? void 0 : ref.map(function(bedroom) {
        var ref;
        return (ref = bedroom.room_title) === null || ref === void 0 ? void 0 : ref.split(" ")[0];
    }));
    var propertyConfiguration = bedroomOptions && helpers_iterateArray(bedroomOptions);
    var returnHeaderWallpaper = function(property) {
        var ref, ref1;
        if (property.cloudflare_image) {
            return (0,getS3Url/* getS3Url */.v)(property.cloudflare_image, "1980");
        }
        if (property.cloudflare_gallery && !(0,isEmpty/* default */.Z)(property.cloudflare_gallery)) {
            return (0,getS3Url/* getS3Url */.v)(property.cloudflare_gallery[0]);
        }
        if (property.image) {
            return property.image;
        }
        if ((ref = property.pictures) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.original) {
            return property.pictures[0].original;
        }
        return null // Explicitly return null if no image is found
        ;
    };
    var findMinimumNights = function(searchDay) {
        return axios/* default.get */.Z.get("https://api.sxmsir.com/api/v1/" + "listings/min-nights", {
            params: {
                listingId: property === null || property === void 0 ? void 0 : property.resource_id,
                startDate: searchDay.format("YYYY-MM-DD")
            }
        }).then(function(res) {
            setMinNights(res.data);
        }).catch(function(error) {
            if (error) {
                console.error(error);
            }
        });
    };
    (0,react.useEffect)(function() {
        if (property && router.locale === moment_default().locale()) {
            search.startDate && findMinimumNights(search.startDate);
        }
    }, [
        search.startDate
    ]);
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingPage["default"], {
            title: loadingTitle[router.locale]
        });
    }
    if (notFound) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {
            headerTranslation: headerTranslation,
            footerTranslation: footerTranslation,
            ctaTranslation: ctaTranslation
        });
    }
    if (property) {
        var ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page["default"], {
            ctaTranslation: ctaTranslation,
            headerTranslation: headerTranslation,
            footerTranslation: footerTranslation,
            title: "".concat(property === null || property === void 0 ? void 0 : property.propertyTitle, " ").concat(property === null || property === void 0 ? void 0 : property.bedrooms, " ").concat((property === null || property === void 0 ? void 0 : property.bedrooms) === 1 ? "Bedroom" : "Bedrooms", " ").concat(property === null || property === void 0 ? void 0 : property.propertyType),
            meta: {
                title: "".concat(property === null || property === void 0 ? void 0 : property.propertyTitle, " ").concat(property === null || property === void 0 ? void 0 : property.bedrooms, " ").concat((property === null || property === void 0 ? void 0 : property.bedrooms) === 1 ? "Bedroom" : "Bedrooms", " ").concat(property === null || property === void 0 ? void 0 : property.propertyType),
                description: (property === null || property === void 0 ? void 0 : property.welcome_description) || (property === null || property === void 0 ? void 0 : property.propertyDescription),
                image: property.cloudflare_image ? (0,getS3Url/* getS3Url */.v)(property.cloudflare_image, "1980") : !(0,isEmpty/* default */.Z)(property.cloudflare_gallery) ? (0,getS3Url/* getS3Url */.v)(property.cloudflare_gallery[0]) : property === null || property === void 0 ? void 0 : property.pictures
            },
            footer: false,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Welcome/* default */.Z, {
                    blockedDates: blockedDates,
                    property: property,
                    minNights: minNights,
                    translations: pageTranslations,
                    video: !(0,isEmpty/* default */.Z)(property.video) && property.video[0],
                    cloudflare: (property === null || property === void 0 ? void 0 : property.cloudflare_header_video) || !(0,isEmpty/* default */.Z)(property.cloudflare_additional_video) && property.cloudflare_additional_video,
                    background: returnHeaderWallpaper(property),
                    configuration: "".concat(property === null || property === void 0 ? void 0 : property.prefix_welcome_label, " ").concat(propertyConfiguration, "\n                      ").concat(property === null || property === void 0 ? void 0 : property.postfix_welcome_label),
                    title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            (property === null || property === void 0 ? void 0 : property.propertyTitle) ? property === null || property === void 0 ? void 0 : property.propertyTitle : (ref4 = property === null || property === void 0 ? void 0 : (ref3 = property.nickname) === null || ref3 === void 0 ? void 0 : ref3.replace(/\w+/g, capitalize/* default */.Z)) === null || ref4 === void 0 ? void 0 : ref4.replaceAll("-", " "),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            property.bedrooms,
                            " Bedroom",
                            "".concat(property.exclusive === 1 ? "Exclusive" : "", " ").concat((property === null || property === void 0 ? void 0 : (ref5 = property.propertyType) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) === "villa" ? "Villa" : "Condo")
                        ]
                    }),
                    sold: !property.is_active,
                    description: (property === null || property === void 0 ? void 0 : property.welcome_description) || (property === null || property === void 0 ? void 0 : property.propertyDescription)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Introduction/* default */.Z, {
                    translations: pageTranslations.introduction,
                    description: property === null || property === void 0 ? void 0 : property.propertyDescription,
                    title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            property === null || property === void 0 ? void 0 : property.propertyTitle,
                            " - ",
                            property === null || property === void 0 ? void 0 : property.bedrooms,
                            " ",
                            "Bedroom ",
                            (0,capitalize/* default */.Z)(property === null || property === void 0 ? void 0 : property.propertyType)
                        ]
                    }),
                    location: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            property === null || property === void 0 ? void 0 : property.city,
                            ", ",
                            property === null || property === void 0 ? void 0 : property.region_side
                        ]
                    }),
                    contact: property === null || property === void 0 ? void 0 : property.introduction_person
                }),
                isAuthorized && /*#__PURE__*/ (0,jsx_runtime.jsx)(single_property_Updates, {
                    title: "".concat(property === null || property === void 0 ? void 0 : property.propertyTitle, " ").concat(pageTranslations.updates.documents[router.locale]),
                    entries: property.updates
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery/* default */.Z, {
                    translations: pageTranslations.gallery,
                    property: property,
                    background: !isAuthorized ? "white" : property.updates && (0,isEmpty/* default */.Z)(property.updates) ? "white" : ""
                }, property.id),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (vacation_rentals_styles_module_default()).grid,
                    children: [
                        !isTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,withModifiers/* withModifiers */.i)("grid__item", [
                                "fixed"
                            ], (vacation_rentals_styles_module_default())),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (vacation_rentals_styles_module_default()).grid__inner,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    translations: pageTranslations.welcome.card,
                                    blockedDates: blockedDates,
                                    property: property,
                                    minNights: minNights
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,withModifiers/* withModifiers */.i)("grid__item", [
                                "first"
                            ], (vacation_rentals_styles_module_default())),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Details/* default */.Z, {
                                translations: pageTranslations.details,
                                bedrooms: bedrooms,
                                bathrooms: bathrooms,
                                common_areas: property.common_areas_description,
                                bathroom_description: property.bathroom_description
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (vacation_rentals_styles_module_default()).grid__item,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Amenities, {
                                translations: pageTranslations.amenities,
                                property: property
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (vacation_rentals_styles_module_default()).grid__item,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Availability/* default */.Z, {
                                title: pageTranslations.availability.title[router.locale],
                                note: pageTranslations.availability.note[router.locale],
                                translations: pageTranslations,
                                cardTranslation: pageTranslations.welcome.card,
                                property: property,
                                blockedDates: blockedDates,
                                minNights: minNights,
                                variant: [
                                    (property === null || property === void 0 ? void 0 : (ref6 = property.address) === null || ref6 === void 0 ? void 0 : ref6.lat) && (property === null || property === void 0 ? void 0 : (ref7 = property.address) === null || ref7 === void 0 ? void 0 : ref7.lng) && "pb0"
                                ]
                            })
                        })
                    ]
                }),
                (property === null || property === void 0 ? void 0 : (ref8 = property.address) === null || ref8 === void 0 ? void 0 : ref8.lat) && (property === null || property === void 0 ? void 0 : (ref9 = property.address) === null || ref9 === void 0 ? void 0 : ref9.lng) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Map/* default */.Z, {
                    variant: [
                        "section"
                    ],
                    lat: property === null || property === void 0 ? void 0 : (ref10 = property.address) === null || ref10 === void 0 ? void 0 : ref10.lat,
                    lng: property === null || property === void 0 ? void 0 : (ref11 = property.address) === null || ref11 === void 0 ? void 0 : ref11.lng
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews, {
                    translations: pageTranslations.reviews,
                    reviews: property.reviews,
                    property: property
                }),
                (property === null || property === void 0 ? void 0 : property.service) && /*#__PURE__*/ (0,jsx_runtime.jsx)(single_property_Bonuses, {
                    title: pageTranslations.bonuses.title[router.locale],
                    label: pageTranslations.bonuses.label[router.locale],
                    services: property === null || property === void 0 ? void 0 : property.service
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Contact, {
                    translations: contactTranslation,
                    buying: false,
                    leftLabel: true,
                    disabled: !property.is_active,
                    staff: property === null || property === void 0 ? void 0 : property.person
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rentals, {
                    title: pageTranslations.rentals.title[router.locale],
                    buttonLabel: pageTranslations.rentals.button[router.locale],
                    properties: recommendedProperties,
                    cardTranslation: headerTranslation.card
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {
        headerTranslation: headerTranslation,
        footerTranslation: footerTranslation
    });
};
var __N_SSG = true;
/* harmony default export */ var _name_ = (Property);


/***/ }),

/***/ 27033:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__IuLil","card__title":"styles_card__title__jSGaV","card__image":"styles_card__image__H6rt_"};

/***/ }),

/***/ 71550:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"experience":"styles_experience__FlC5N","locations":"styles_locations__HHYbw","column":"styles_column__cJLvg"};

/***/ }),

/***/ 94411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"intro":"styles_intro__zkIY1","title":"styles_title__J0bjh"};

/***/ }),

/***/ 56170:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__C0qeL","update":"styles_update__ciFgD","update__content":"styles_update__content__jRAyw","update__left":"styles_update__left__NOV1x","update__bullet":"styles_update__bullet__neS72","update__right":"styles_update__right__dNnA5"};

/***/ }),

/***/ 76283:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__sV1cA","section__content":"styles_section__content__8elFi","grid":"styles_grid__Hbyvc","grid__inner":"styles_grid__inner___pc7s","grid__item":"styles_grid__item__pkBii","grid__item--first":"styles_grid__item--first__tD0H5","grid__item--fixed":"styles_grid__item--fixed__Oc227"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3790,2756,5675,175,6820,8433,939,5798,3808,6622,5562,3817,5444,7713,7329,5235,9774,945,2888,179], function() { return __webpack_exec__(16134); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);